import router from "@/router";
import store from "@/store";
import axios from "axios";
import cancelClass from "@/plugins/cancelToken";

const whiteList = ["/login", "/locale", "/info", "/token", "/unauth", "/debug.htm"];

router.beforeEach(async (to, from, next) => {
  cancelClass.cancelRequest.source.cancel &&
    cancelClass.cancelRequest.source.cancel("Cancel Request for" + from.path);
  cancelClass.cancelRequest.source = axios.CancelToken.source();
  if (whiteList.indexOf(to.path) !== -1) {
    next();
  } else {
    const token = await store.dispatch("user/getToken");
    if (token == "") {
      if (to.path.includes("login") || to.path.includes("index")) {
        next({ name: "login" });
      } else {
        next({ name: "login", params: { redirect: to.path } });
      }
    } else {
      next();
    }
  }
});
